import { SecondaryText, SingleCardItem, SubTitle, Title } from "components/views/ui";

const IERAECTF2025 = () => {
    return (
        <SingleCardItem>
            <Title
                title={
                    "IERAE CTF 2025"
                }
                hyperLink="https://gmo-cybersecurity.com/event/ieraectf25/"
            />
            <SubTitle title={"06/2025"} />
            <SecondaryText text={"Ranking: 16 / 538"} />
        </SingleCardItem>
    );
};

export default IERAECTF2025;
